import React from 'react';

function formatSlotLabel(teamName) {
  if (!teamName) return teamName;
  const match = String(teamName).match(/^Team(\d+)$/i);
  return match ? `Team ${match[1]}` : teamName;
}

export default function TeamSlotGrid({ slots, title = 'Team slots' }) {
  if (!slots || slots.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontWeight: 600, color: '#374151', marginBottom: 8, fontSize: 14 }}>
        {title}
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
          gap: 8,
        }}
      >
        {slots.map((slot) => (
          <div
            key={slot.team_name}
            style={{
              padding: '8px 10px',
              borderRadius: 6,
              textAlign: 'center',
              fontSize: 13,
              fontWeight: 600,
              background: slot.filled ? '#f1f5f9' : '#f0fdf4',
              border: `1px solid ${slot.filled ? '#cbd5e1' : '#bbf7d0'}`,
              color: slot.filled ? '#64748b' : '#059669',
            }}
          >
            <div>{formatSlotLabel(slot.team_name)}</div>
            <div style={{ fontSize: 11, fontWeight: 500, marginTop: 2 }}>
              {slot.filled ? 'Taken' : 'Open'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
